export default "__VITE_ASSET__DRG_2d$9__"